import ExportButton from "components/ExportButton/ExportButton";
import { activityStatusById } from "features/activity/activityConsts";
import { useGetAllActivityItemsQuery } from "features/activity/activitySlice";
import { orderBy } from "lodash";
import FormatService from 'services/formatService';
import { arrayToObject } from "utils/object-util";
import { useGetStatusesForClientQuery } from 'features/vehicles/VehicleStatus/vehicleStatusSlice';

export const InvoiceBasicExport = ({ invoiceData }) => {

    let { data: activityItems, error: activityItemsError, isFetching: isLoadingActivityItems } = useGetAllActivityItemsQuery();
    let { data: vehicleStatuses, error: statusError, isLoading: isLoadingStatuses } = useGetStatusesForClientQuery({ clientId: 0 });
    const statusLookup = arrayToObject(vehicleStatuses);
    const activityItemLookup = arrayToObject(activityItems);
    //TODO reorganize all these exports!!
    const getTimeFrameInvoiceReport = () => {
        var invoiceList = [];

        var activities = invoiceData?.storageInvoiceDetails?.flatMap(act => act.storageInvoiceActivities);
        var storage = invoiceData?.storageInvoiceDetails?.flatMap(act => act.storageInvoiceVehicles?.map(s => ({ ...s, baseRate: act.baseRate }))) ?? [];

        var lots = storage?.map(l => ({ id: l.lotId, name: l.lotName }));
        var lotLookup = arrayToObject(lots);
        storage?.map(s => {
            invoiceList.push({
                ['VIN']: s.vin,
                ['Current Location']: s.lotName,
                ['Year']: s.year,
                ['Make']: s.make,
                ['Model']: s.model,
                ['Status']: statusLookup?.[s.statusId]?.name ?? s.statusId,
                //['Cycle start']: s.cycleStart,
                //['Cycle end']: s.cycleEnd,
                ['Storage start']: FormatService.formatDateNoConversion(lotLookup?.[s?.lotId]?.ianaTimeZone ? FormatService.formatDateByTimeZone(s.checkInDate, lotLookup?.[s?.lotId]?.ianaTimeZone) : s.checkInDate),
                ['Check-in fee']: s.checkInCountInCycle * s.checkInFee,
                ['Release date']: s.checkOutDate ? FormatService.formatDateNoConversion(lotLookup?.[s?.lotId]?.ianaTimeZone ? FormatService.formatDateByTimeZone(s.checkOutDate, lotLookup?.[s?.lotId]?.ianaTimeZone) : s.checkOutDate) : '',
                ['Release fee']: s.checkOutCountInCycle * s.checkOutFee,
                ['Activity action']: '',
                ['Activity status']: '',
                ['Activity date']: '',
                ['Storage days']: s.billedDays,
                ['Charge']: '',
                ['Storage fee']: s.billedDays * s.baseRate
            })
        });

        activities?.map(s => {
            invoiceList.push({
                ['VIN']: s.vin,
                ['Current Location']: lotLookup[s.lotId]?.name ?? s.lotId,
                ['Year']: s.year,
                ['Make']: s.make,
                ['Model']: s.model,
                ['Activity action']: activityItemLookup?.[s.activityItemId]?.name ?? s.description,
                ['Activity status']: activityStatusById?.[s.activityStatus]?.name ?? s.activityStatus,
                ['Activity date']: FormatService.formatDateNoConversion(lotLookup?.[s?.lotId]?.ianaTimeZone ? FormatService.formatDateByTimeZone(s.activityDate, lotLookup?.[s?.lotId]?.ianaTimeZone) : s.activityDate),
                ['Charge']: s.totalCharge,
                ['Storage fee']: 0
            })
        });

        return orderBy(invoiceList, ['Lot', 'VIN'], ['asc']);
    }

    return (
        <ExportButton
            fileLabel={`Invoice Report ${invoiceData?.cycleStartFormatted} - ${invoiceData?.cycleEndFormatted}`}
            data={getTimeFrameInvoiceReport()}
            className=''
            isDataReadyForExport
            label='Export'
        />
    );
}